<template>
  <b-modal size="lg" ref="modal" @close="close" centered no-close-on-backdrop>
    <template #modal-header="{ close }">
      <h5 class="font-weight-bolder m-0">User Details</h5>

      <b-button
        size="sm"
        variant="none"
        class="btn-icon btn-circle btn-hover-dark"
        title="Close"
        @click="close"
        v-b-tooltip.hover
      >
        <i class="material-icons icon-xl">close</i>
      </b-button>
    </template>

    <template #default v-if="fetching">
      <div class="d-flex align-items-center justify-content-center">
        Loading...
      </div>
    </template>
    <template #default v-else>
      <div
        class="alert text-center font-weight-bolder"
        :class="variants"
        v-if="error && error.length"
      >
        {{ error }}
      </div>

      <div class="row mb-3">
        <div class="col-4 font-weight-bolder text-right">Name</div>
        <div class="col-8">
          {{ user.first_name || "-" }} {{ user.last_name || "-" }}
        </div>
      </div>

      <div class="row mb-3">
        <div class="col-4 font-weight-bolder text-right">Email</div>
        <div class="col-8">{{ user.email || "-" }}</div>
      </div>

      <div class="row mb-3">
        <div class="col-4 font-weight-bolder text-right">Groups</div>
        <div class="col-8">
          {{
            (user &&
              user.groups &&
              user.groups.length &&
              user.groups.map((group) => group && group.name).join(", ")) ||
            "-"
          }}
        </div>
      </div>

      <div class="row mb-3">
        <div class="col-4 font-weight-bolder text-right">Permissions</div>
        <div class="col-8">
          {{
            (user &&
              user.permissions &&
              user.permissions.length &&
              user.permissions
                .map((permission) =>
                  permission
                    ? `${capitalizeFirstLetter(
                        permission.split(":")[1]
                      )} ${capitalizeFirstLetter(permission.split(":")[0])}`
                    : ""
                )
                .join(", ")) ||
            "-"
          }}
        </div>
      </div>
    </template>

    <template #modal-footer="{ close }">
      <div class="d-flex justify-content-between mx-auto">
        <b-button
          class="btn-pill font-weight-bold"
          variant="dark"
          :disabled="disabled"
          @click="close"
        >
          <span>Close</span>
        </b-button>
      </div>
    </template>
  </b-modal>
</template>

<script>
import UsersService from "@/services/users.service";
import { formatErrorMessage } from "@/utils/random_utils";

export default {
  name: "Details",
  methods: {
    capitalizeFirstLetter(string) {
      return string.charAt(0).toUpperCase() + string.slice(1);
    },
    async fetch(id) {
      this.fetching = true;

      UsersService.get(id)
        .then(({ data }) => {
          this.user = data;
        })
        .catch(({ message }) => {
          this.error = formatErrorMessage(message);
        })
        .finally(() => {
          this.fetching = false;
        });
    },
    open(id) {
      this.error = null;
      this.fetching = false;
      this.user = {};

      this.fetch(id);

      this.$refs["modal"].show();
    },
    close(event) {},
  },
  computed: {
    disabled() {
      return this.sending;
    },
    variants() {
      return {
        show: this.error,
        "alert-light-danger": this.error,
      };
    },
  },
  data() {
    return {
      error: null,
      fetching: false,
      user: {},
    };
  },
};
</script>
